import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { SecurityApiClient } from "../api-client/api-client";
import type {
  ValidationSensitiveEmailCodeParams,
  ValidationSensitiveEmailCodeResponse
} from "../types";

export default function useValidateSensitiveEmailMutation(
  options?: UseMutationOptions<
    ValidationSensitiveEmailCodeResponse,
    Error,
    ValidationSensitiveEmailCodeParams
  >
) {
  const queryClient = useQueryClient();
  return useMutation<
    ValidationSensitiveEmailCodeResponse,
    Error,
    ValidationSensitiveEmailCodeParams
  >({
    mutationFn: async (params: ValidationSensitiveEmailCodeParams) => {
      const res = await SecurityApiClient.validateSensitiveEmail(
        params.uuidSensitiveActionValidation,
        params.code,
        params.actionType
      );
      if (!res.success) {
        throw new Error(res.message);
      }
      return res;
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["user", "profile"] }),
    ...options
  });
}
